"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = {
  name: 'App',
  created: function created() {
    //先取缓存 然后再加载
    if (localStorage.getItem('BASE_DATA')) {
      var baseData = JSON.parse(localStorage.getItem('BASE_DATA'));
      if (baseData) this.$store.commit("setBaseData", baseData);
    } //console.info('get base data from localstorage', 'products', this.$store.state.panel.products)
    //获取常用值 如渠道，省市区,商品等


    this.$store.dispatch("BASE_DATA");
  },
  mounted: function mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    handleBeforeUnload: function handleBeforeUnload(event) {// cicGlobal.logout();
      // cicGlobal.disconnect();
    }
  }
};
exports.default = _default;